import { BasePayloadMapper } from '@ps/utils';
import { SupplierAccessPayloadDto } from '../dtos/supplier.dto';
import { SUPPLIER_DTO_STATUS } from '../dtos/supplier.constants';
import { SupplierAccessSave } from '../../models/supplier.model';

export class SupplierAccessPayloadMapper extends BasePayloadMapper<
  SupplierAccessSave,
  SupplierAccessPayloadDto
> {
  public toPayload(model: SupplierAccessSave): SupplierAccessPayloadDto {
    return {
      companyId: model.buyerId,
      supplierList: model.suppliers.map((supplier) => ({
        supplierId: supplier.id,
        supplierStatus: supplier.blocked
          ? SUPPLIER_DTO_STATUS.BLOCKED
          : SUPPLIER_DTO_STATUS.ACTIVE,
      })),
    };
  }
}
